import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { useForm } from "react-hook-form";

import {
  Grid,
  IconButton,
  Avatar,
  TextField,
  Button,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Typography,
  Chip,
  Checkbox,
} from "@material-ui/core";

import {
  Edit,
  CheckCircle,
  Cancel,
  CheckBoxOutlined,
  CheckBoxOutlineBlank,
  Launch,
  Check,
  CheckBoxOutlineBlankIcon,
  CheckBox,
} from "@material-ui/icons";
import MoveToInboxIcon from "@material-ui/icons/MoveToInbox";
import { FileText } from "react-feather";

import styles from "./Item.module.css";
import { AvatarParticipante } from "./components";
import serviciosTablero from "utils/serviciosTablero";
import Tarjeta from "views/PruebaDnd/components/Tarjeta";
import TarjetaAdmin from "views/PruebaDnd/components/TarjetaAdmin";
import { useStylesTablero } from "views/Tablero/utils/stylesTablero";
import { getColoresFecha } from "../../utils/funcionesFechasTarjeta";

export const Item = React.memo(
  React.forwardRef(
    (
      {
        color,
        dragOverlay,
        dragging,
        disabled,
        fadeIn,
        handle,
        handleProps,
        height,
        index,
        listeners,
        onRemove,
        renderItem,
        sorting,
        style,
        transition,
        transform,
        value,
        wrapperStyle,
        dataEtapa,
        dataTarjeta,
        dataGeneral,
        infoTablero,
        setData,
        setCargando,
        setMensaje,
        cargarTablero,
        updateData,
        idjerarquia,
        usuario,
        permisos,
        ...props
      },
      ref
    ) => {
      const stylesTarjeta = {
        border: "1px solid #aaa",
        backgroundColor: "#ffff",
        boxShadow: "0.5px 0.5px 0.5px 1px #aaaaaa5c",
        textOverflow: "unset",
        textWrap: "pretty",
        textAlign: "justify",
      };
      const stylesEtiqueta = {
        textOverflow: "unset",
        textWrap: "pretty",
        textAlign: "justify",
        overflowWrap: "anywhere",
        borderRadius: "5px",
        color: "#ffff",
        padding: "0 10px 0 10px",
      };
      const styleListCheck = {
        fontFamily: "Roboto",
        fontSize: "smaller",
        color: "gray",
      };
      const classesTablero = useStylesTablero();
      const [esEdit, setEsEdit] = useState(false);
      const [modalTarjeta, setModalTarjeta] = useState({ open: false });
      const [modalTarjetaAdmin, setModalTarjetaAdmin] = useState({
        open: false,
      });
      const [participantesTarjeta, setParticipantesTarjeta] = useState(
        dataTarjeta?.participantes || []
      );
      const [etiquetasTarjeta, setEtiquetasTarjeta] = useState(
        dataTarjeta?.etiquetas || []
      );
      const [listasTarjeta, setListasTarjeta] = useState(
        dataTarjeta?.progreso || ""
      );
      const [fechasTarjeta, setFechasTarjeta] = useState({
        fechaInicio: dataTarjeta?.finicio,
        fechaFinal: dataTarjeta?.ffin,
      });
      const { register, getValues } = useForm();

      const cerrarModalTarjeta = () => setModalTarjeta({ open: false });
      const cerrarModalTarjetaAdmin = () =>
        setModalTarjetaAdmin({ open: false });
      const guardarDescripcion = () => {
        serviciosTablero.updateTituloTarjeta(
          (status, mensaje, data) => {
            let etapaOfTarjeta = null;
            dataGeneral.map((etapa) => {
              let etapaFind = etapa.tarjetas.find(
                (tarjeta) => tarjeta.idtarjeta == dataTarjeta.idtarjeta
              );
              if (etapaFind) {
                etapaOfTarjeta = etapa;
                return;
              }
            });

            let indexEtapa = dataGeneral.indexOf(etapaOfTarjeta);
            let indexTarjeta = dataGeneral[indexEtapa].tarjetas.indexOf(
              dataTarjeta
            );
            let nuevaDataGeneral = dataGeneral;
            nuevaDataGeneral[indexEtapa].tarjetas[
              indexTarjeta
            ].titulo = getValues("descripcionTarjeta");

            setData(nuevaDataGeneral);
            setEsEdit(false);
            setMensaje({ open: true, status: status, value: mensaje });
          },
          setCargando,
          {
            idtarjeta: dataTarjeta.idtarjeta,
            titulo: getValues("descripcionTarjeta"),
          }
        );
      };
      const abrirModalTarjeta = () => {
        if (infoTablero?.idtipo == 2) {
          
          // Si es tablero de seguimiento no abrir modal
          const propsModal = {
            data: dataTarjeta,
            dataGeneral: dataGeneral,
            dataEtapa: dataEtapa,
          };

          setModalTarjetaAdmin({
            open: true,
            titulo: "Informacion tarjeta",
            contenido: (
              <>
                <Button {...propsModal}>Hola</Button>
              </>
            ),
            props: {
              data: dataTarjeta,
              dataGeneral: dataGeneral,
              dataEtapa: dataEtapa,
            },
          });

          return;
        }
        const propsModal = {
          data: dataTarjeta,
          dataGeneral: dataGeneral,
          dataEtapa: dataEtapa,
        };
        setModalTarjeta({
          open: true,
          titulo: "Informacion tarjeta",
          contenido: (
            <>
              <Button {...propsModal}>Hola</Button>
            </>
          ),
          props: {
            data: dataTarjeta,
            dataGeneral: dataGeneral,
            dataEtapa: dataEtapa,
          },
        });
      };

      const [open, setOpen] = useState(false);
      const [currentData, setCurrentData] = useState(null);

      const handleArchivar = (data) => {
        setCurrentData(data);
        setOpen(true);
      };

      const handleConfirmar = () => {
        serviciosTablero.archivarTarjeta(
          (status, mensaje, data) => {
            if (status === 1) {
              setMensaje({ open: true, status: status, value: mensaje });
              cargarTablero();
            }
          },
          setCargando,
          { idtarjeta: currentData?.idtarjeta, idestatus: -1 }
        );
        setOpen(false);
      };

      const handleCancelar = () => {
        setOpen(false);
      };

      const getTipoFecha = (fecha) => {
        let fechaActual = new Date();
        let fechaFinObj = new Date(fecha);
        // Convertir ambas fechas a la misma zona horaria para evitar errores
        let fechaActualMidnight = new Date(fechaActual.setHours(0, 0, 0, 0));
        let fechaFinMidnight = new Date(fechaFinObj.setHours(0, 0, 0, 0));

        let diferenciaDias = Math.ceil(
          (fechaFinMidnight - fechaActualMidnight) / (1000 * 60 * 60 * 24)
        );

        if (diferenciaDias <= 1 && diferenciaDias >= 0) {
          return "pronto";
        } else if (diferenciaDias < 0) {
          return "vencido";
        } else {
          return "";
        }
      };

      //FECHAS

      useEffect(() => {
        if (!dragOverlay) {
          return;
        }
        document.body.style.cursor = "grabbing";
        return () => {
          document.body.style.cursor = "";
        };
      }, [dragOverlay, etiquetasTarjeta, listasTarjeta, participantesTarjeta]);

      return renderItem ? (
        renderItem({
          dragOverlay: Boolean(dragOverlay),
          dragging: Boolean(dragging),
          sorting: Boolean(sorting),
          index,
          fadeIn: Boolean(fadeIn),
          listeners,
          ref,
          style,
          transform,
          transition,
          value,
        })
      ) : (
        <li
          className={classNames(
            styles.Wrapper,
            fadeIn && styles.fadeIn,
            sorting && styles.sorting,
            dragOverlay && styles.dragOverlay
          )}
          style={{
            ...wrapperStyle,
            transition: [transition, wrapperStyle?.transition]
              .filter(Boolean)
              .join(", "),
            "--translate-x": transform
              ? `${Math.round(transform.x)}px`
              : undefined,
            "--translate-y": transform
              ? `${Math.round(transform.y)}px`
              : undefined,
            "--scale-x": transform?.scaleX ? `${transform.scaleX}` : undefined,
            "--scale-y": transform?.scaleY ? `${transform.scaleY}` : undefined,
            "--index": index,
            "--color": color,
          }}
          ref={ref}
        >
          <Tooltip
            title={
              fechasTarjeta?.fechaInicio ||
              !dataTarjeta ||
              infoTablero?.idtipo == 2
                ? ""
                : "Asigna fechas para mover"
            }
          >
            <Grid container spacing={0}>
              <Grid item xs={12}>
                {!esEdit ? (
                  <div
                    className={classNames(
                      styles.Item,
                      dragging && styles.dragging,
                      handle && styles.withHandle,
                      dragOverlay && styles.dragOverlay,
                      disabled && styles.disabled,
                      color && styles.color
                    )}
                    style={{ ...style, ...stylesTarjeta }}
                    data-cypress="draggable-item"
                    {...props}
                    tabIndex={!handle ? 0 : undefined}
                  >
                    <Grid container spacing={0}>
                      <Grid item xs={12}>
                        <Grid container spacing={0}>
                          <Grid
                            item
                            xs={9}
                            //onClick={abrirModalTarjeta}
                            {...(!handle &&
                            (infoTablero?.idtipo == 1
                              ? fechasTarjeta?.fechaInicio // Si el tablero normal validamos que tenga fecha
                              : [2, 3].includes(usuario[0]?.idrol)) // Si es tablero general validamos que sea gerente o director
                              ? listeners
                              : undefined)}
                          >
                            <Grid container spacing={0}>
                              {etiquetasTarjeta &&
                                etiquetasTarjeta?.map((etiqueta) => (
                                  <Grid item xs={6}>
                                    <p
                                      style={{
                                        ...stylesEtiqueta,
                                        backgroundColor:
                                          etiqueta?.color || "gray",
                                      }}
                                    >
                                      {etiqueta?.nombre || ""}
                                    </p>
                                  </Grid>
                                ))}
                            </Grid>
                          </Grid>
                          <Grid
                            item
                            xs={3}
                            style={{ paddingLeft: "15px", marginTop: "-20px" }}
                          >
                            <Grid container spacing={1}>
                              <Grid item xs={6}>
                                <IconButton
                                  onClick={abrirModalTarjeta}
                                  title="Abrir tarjeta"
                                >
                                  <Launch fontSize="small" />
                                </IconButton>
                              </Grid>
                              {infoTablero?.idtipo == 1 && (
                                <Grid item xs={6}>
                                  <IconButton
                                    onClick={() => {
                                      setEsEdit(true);
                                    }}
                                    title="Editar descripcion"
                                    style={{ color: "#ffb74d" }}
                                  >
                                    <Edit fontSize="small" />
                                  </IconButton>
                                </Grid>
                              )}
                              <Grid item xs={6}>
                                {infoTablero?.idtipo == 2 && [2, 3].includes(usuario[0]?.idrol) && (
                                  <IconButton
                                    onClick={() => {
                                      handleArchivar(dataTarjeta);
                                    }}
                                    title="Archivar"
                                    style={{ color: "#e57373" }}
                                  >
                                    <MoveToInboxIcon fontSize="small" />
                                  </IconButton>
                                )}
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{
                          marginTop: "10px",
                          cursor: "grab",
                          fontFamily: "Arial",
                          fontSize: "0.9em",
                          textAlign: "left",
                        }}
                        {...(!handle &&
                        (infoTablero?.idtipo == 1
                          ? fechasTarjeta?.fechaInicio // Si el tablero normal validamos que tenga fecha
                          : [2, 3].includes(usuario[0]?.idrol)) // Si es tablero general validamos que sea gerente o director
                          ? listeners
                          : undefined)}
                      >
                        {infoTablero?.idtipo == 1
                          ? dataTarjeta?.titulo || "Ordenando tarjeta..."
                          : dataTarjeta?.nsolicitud || "Ordenando tarjeta..."}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{ marginTop: "10px" }}
                        //onClick={abrirModalTarjeta}
                        {...(!handle &&
                        (infoTablero?.idtipo == 1
                          ? fechasTarjeta?.fechaInicio // Si el tablero normal validamos que tenga fecha
                          : [2, 3].includes(usuario[0]?.idrol)) // Si es tablero general validamos que sea gerente o director
                          ? listeners
                          : undefined)}
                      >
                        <Grid container spacing={1}>
                          <Grid item xs={5} style={styleListCheck}>
                            <Grid container spacing={0}>
                              {listasTarjeta && listasTarjeta !== "" && (
                                <Grid item xs={6}>
                                  <Grid container spacing={1}>
                                    {listasTarjeta &&
                                      listasTarjeta
                                        ?.split(",")
                                        ?.map((progreso) => (
                                          <Grid
                                            item
                                            xs={6}
                                            style={{ fontSize: "11px" }}
                                          >
                                            <CheckBoxOutlined fontSize="small" />{" "}
                                            {progreso || ""}
                                          </Grid>
                                        ))}
                                  </Grid>
                                </Grid>
                              )}
                              {dataTarjeta?.idsolicitud && (
                                <Grid item xs={6}>
                                  <Grid
                                    container
                                    alignItems="center"
                                    spacing={1}
                                  >
                                    <Grid item xs={6}>
                                      <Tooltip
                                        title={dataTarjeta?.nsolicitud || ""}
                                      >
                                        <FileText size="20" />
                                      </Tooltip>
                                    </Grid>
                                    <Grid item xs={6}>
                                      <span>
                                        {dataTarjeta?.idsolicitud || ""}
                                      </span>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              )}
                            </Grid>
                          </Grid>
                          <Grid item xs={2} />
                          <Grid
                            item
                            xs={5}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "end",
                              alignItems: "flex-end",
                            }}
                          >
                            {participantesTarjeta.map(
                              (dataParticipante, index) => {
                                if (index > 3) return;
                                return index <= 2 ? (
                                  <AvatarParticipante
                                    infoColaborador={dataParticipante}
                                  />
                                ) : (
                                  <Avatar
                                    style={{
                                      width: "30px",
                                      height: "30px",
                                      fontSize: "small",
                                      backgroundColor: "gray",
                                      marginRight: "-5px",
                                    }}
                                  >
                                    {"+" +
                                      (dataTarjeta.participantes.length - 3)}
                                  </Avatar>
                                );
                              }
                            )}
                          </Grid>
                        </Grid>
                        <Grid container style={{ marginTop: "10px" }}>
                          <Grid item xs={12}>
                            {fechasTarjeta?.fechaInicio &&
                              fechasTarjeta?.fechaFinal && (
                                <Grid item xs={3}>
                                  <Grid container spacing={1}>
                                    {/* CHIP */}
                                    <Chip
                                      size="small"
                                      label={
                                        <div
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "8px",
                                          }}
                                        >
                                          <Typography>
                                            {new Date(
                                              fechasTarjeta?.fechaInicio
                                            ).toLocaleDateString("es-ES", {
                                              day: "2-digit",
                                              month: "short",
                                            }) +
                                              "-" +
                                              new Date(
                                                fechasTarjeta?.fechaFinal
                                              ).toLocaleDateString("es-ES", {
                                                day: "2-digit",
                                                month: "short",
                                              })}
                                          </Typography>
                                        </div>
                                      }
                                      // onClick={handleToggle}
                                      style={{
                                        cursor: "pointer",
                                        color: dataTarjeta?.fecha_entregado
                                          ? getColoresFecha("completado")?.color
                                          : getColoresFecha(
                                              getTipoFecha(
                                                fechasTarjeta?.fechaFinal
                                              )
                                            )?.color,
                                        backgroundColor: dataTarjeta?.fecha_entregado
                                          ? getColoresFecha("completado")
                                              ?.background
                                          : getColoresFecha(
                                              getTipoFecha(
                                                fechasTarjeta?.fechaFinal
                                              )
                                            )?.background,
                                      }}
                                    />
                                  </Grid>
                                </Grid>
                              )}
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </div>
                ) : (
                  <div
                    style={{ ...style, ...stylesTarjeta }}
                    className={classNames(
                      styles.Item,
                      dragging && styles.dragging,
                      handle && styles.withHandle,
                      dragOverlay && styles.dragOverlay,
                      disabled && styles.disabled,
                      color && styles.color
                    )}
                  >
                    <form>
                      <Grid container spacing={1}>
                        <Grid item xs={9}>
                          <TextField
                            variant="filled"
                            multiline={true}
                            name="descripcionTarjeta"
                            defaultValue={dataTarjeta?.titulo}
                            inputRef={register({
                              required: {
                                value: true,
                                message: "Campo requerido",
                              },
                            })}
                            inputProps={{ style: { color: "#000000" } }}
                          />
                        </Grid>
                        <Grid item xs={1}>
                          <IconButton
                            onClick={() => {
                              guardarDescripcion(dataEtapa);
                            }}
                            title="Guardar"
                            style={{
                              color: "FFFFFF",
                              backgroundColor: "transparent",
                            }}
                          >
                            <Check />
                          </IconButton>
                        </Grid>
                        <Grid item xs={2}>
                          <IconButton
                            onClick={() => {
                              setEsEdit(false);
                            }}
                            title="Cancelar"
                            style={{ color: "#e57373", marginLeft: "15px" }}
                          >
                            <Cancel />
                          </IconButton>
                        </Grid>
                      </Grid>
                    </form>
                  </div>
                )}
              </Grid>
            </Grid>
          </Tooltip>
          <Dialog open={open} onClose={handleCancelar}>
            <DialogTitle>Confirmar archivo</DialogTitle>
            <DialogContent>
              <Typography variant="body1">
                La tarjeta se archivará y ya no se mostrará en el tablero,
                ¿desea continuar?
              </Typography>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={handleCancelar}
                className={classesTablero.btnCancelar}
              >
                Cancelar
              </Button>
              <Button
                onClick={handleConfirmar}
                className={classesTablero.btnAceptar}
              >
                Confirmar
              </Button>
            </DialogActions>
          </Dialog>
          <Tarjeta
            open={modalTarjeta.open}
            onClose={cerrarModalTarjeta}
            titulo={modalTarjeta?.titulo || "Advertencia"}
            tarjeta={dataTarjeta}
            setCargando={setCargando}
            setMensaje={setMensaje}
            setParticipantesTarjeta={setParticipantesTarjeta}
            setEtiquetasTarjeta={setEtiquetasTarjeta}
            setListasTarjeta={setListasTarjeta}
            infoTablero={infoTablero}
            cargarTablero={cargarTablero}
            updateData={updateData}
            idjerarquia={idjerarquia}
            usuario={usuario}
            permisos={permisos}
            dataEtapa={dataEtapa}
            setFechasTarjeta={setFechasTarjeta}
          />
          <TarjetaAdmin
            open={modalTarjetaAdmin.open}
            onClose={cerrarModalTarjetaAdmin}
            titulo={modalTarjetaAdmin?.titulo || "Advertencia"}
            props={modalTarjetaAdmin?.props}
            dataEtapa={dataEtapa}
            tarjeta={dataTarjeta}
            setCargando={setCargando}
          />
        </li>
      );
    }
  )
);

export default Item;
